import React from 'react';
import { getCoachInitials } from './coachUtils';

const TypingIndicator = ({ promptInfo }) => (
  <div className="flex items-end gap-2 mb-6 group justify-start animate-fade opacity-100">
    {/* Coach Avatar */}
    <div className="relative">
      <div className="w-8 h-8 rounded-full bg-gray-600 flex items-center justify-center flex-shrink-0">
        <span className="text-white text-xs font-medium">
          {getCoachInitials(promptInfo)}
        </span>
      </div>
    </div>

    {/* Typing bubble — single breathing pill (Apple-style) */}
    <div className="relative">
      <div className="px-4 py-3 rounded-2xl rounded-bl-sm bg-gray-700 shadow-sm">
        <div className="flex items-center space-x-1.5">
          <span className="block w-2 h-2 rounded-full bg-gray-400 animate-typing-pulse" style={{ animationDelay: '0ms' }} />
          <span className="block w-2 h-2 rounded-full bg-gray-400 animate-typing-pulse" style={{ animationDelay: '200ms' }} />
          <span className="block w-2 h-2 rounded-full bg-gray-400 animate-typing-pulse" style={{ animationDelay: '400ms' }} />
        </div>
      </div>
    </div>
  </div>
);

export default TypingIndicator;
